import gerenciamento from './gerenciamentoRepository'
import parametrizacao from './parametrizacaoRepository'
import relatorioSolicitacoes from './relatorioSolicitacoesRepository'
import solicitacao from './solicitacaoRepository'

export default baseUrl => {

    baseUrl = `${baseUrl}/manutencao`

    return {
        gerenciamento: gerenciamento(baseUrl),
        parametrizacao: parametrizacao(baseUrl),
        relatorioSolicitacoes: relatorioSolicitacoes(baseUrl),
        solicitacao: solicitacao(baseUrl),
    }
}